import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb } from "react-bootstrap";
import { addUser, getYoutubeById } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/extra/loading";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ViewMessageIndex = () => {
  const { editId } = useParams();
  const dispatch = useDispatch();
  const [data, setData] = useState({
    name: "",
    documents: [],
    template_categories_id: "",
    template_categories_name: "",
  });
  const [isLoading, setLoading] = useState(false);
  const MessageData = useSelector((s) => s.Signatures?.youtube?.data);

  useEffect(() => {
    dispatch(getYoutubeById(editId));
  }, [editId]);

  const handleConvertClient = (e) => {
    e.preventDefault();

    let body = {
      FirstName: MessageData?.firstname,
      LastName: MessageData?.lastname,
      Email: MessageData?.email,
      CellPhone: MessageData?.phone,
    };
    const callback = (res) => {
      if (res.data) {
        toast.success("User Added Successfully");
      }
    };
    dispatch(addUser(body, callback));
  };
  return (
    <>
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/youtube-messages">
                    Messages
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
          </Row>
          <div className="bg-white px-4 py-3 card-box">
            <Row>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  First Name
                </label>
                <input
                  type="text"
                  value={MessageData?.firstname}
                  className="form-control text-capitalize"
                  disabled
                />
              </Col>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  last Name
                </label>
                <input
                  type="text"
                  value={MessageData?.lastname}
                  className="form-control text-capitalize"
                  disabled
                />
              </Col>
            </Row>
            <Row>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Email
                </label>
                <input
                  type="text"
                  value={MessageData?.email}
                  className="form-control"
                  disabled
                />
              </Col>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Phone
                </label>
                <input
                  type="text"
                  value={MessageData?.phone}
                  className="form-control text-capitalize"
                  disabled
                />
              </Col>
            </Row>
            <div className="top my-3">
              <h4 className="dashboard-head m-0">Message</h4>
            </div>
            <Row className="radio-wrp mt-3">
              <textarea
                className="form-control"
                value={MessageData?.message}
                cols="20"
                rows="7"
                disabled
              ></textarea>
            </Row>

            <div className="d-flex send-btn-div gap-10">
              <div className="text-end mt-3">
                <Link
                  className="btn btn-primary send-btnn"
                  to={`/subscriber/mail/youtube/${MessageData?.id}`}
                >
                  Send Mail
                </Link>
              </div>
              <div className="text-end mt-3">
                <Link
                  className="btn btn-primary send-btnn"
                  to={`/subscriber/sms/youtube/${MessageData?.id}`}
                >
                  Send SMS
                </Link>
              </div>
              <div className="text-end mt-3">
                <Button onClick={handleConvertClient}>Convert to Client</Button>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};
export default ViewMessageIndex;
